import Phaser from 'phaser';

/** Coins d'un rectangle (cx,cy,w,h) pivoté de `angle`, en coordonnées monde. */
export function rectCorners(
  cx: number,
  cy: number,
  w: number,
  h: number,
  angle: number,
): Phaser.Math.Vector2[] {
  const hw = w / 2;
  const hh = h / 2;
  const c = Math.cos(angle);
  const s = Math.sin(angle);
  const local: ReadonlyArray<readonly [number, number]> = [
    [-hw, -hh],
    [hw, -hh],
    [hw, hh],
    [-hw, hh],
  ];
  return local.map(([px, py]) => new Phaser.Math.Vector2(cx + px * c - py * s, cy + px * s + py * c));
}
